import axios from "axios";
import { beautyBaseUrl } from "network";
import { store } from "store";

// Upload Image Function
export const uploadImage = async (file) => {
    try {
        const token = store.getState().auth.token;

        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(
            `${beautyBaseUrl}/setting/addmedia`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        console.log("Upload response:", response);

        const fileName = response.data.data.image;
        console.log("fileName:", fileName);

        return fileName;
    } catch (error) {
        console.error("Image upload failed", error);
        throw error;
    }
};

// Delete Image Function
export const deleteImage = async (imagePath) => {
    try {
        const token = store.getState().auth.token;

        const response = await axios.delete(
            `${beautyBaseUrl}/setting/deleteMedia`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    filename: imagePath, // 🔁 Must go inside "data" field
                },
            }
        );

        console.log("Delete response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Image delete failed", error);
        throw error;
    }
};

